import { render, staticRenderFns } from "./OptionPrices.vue?vue&type=template&id=39d73a30"
import script from "./OptionPrices.vue?vue&type=script&lang=js"
export * from "./OptionPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports